import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { SkeletonBox } from '../../SkeletonBox/SkeletonBox.es.js';
import { useStatusTrackContext } from '../StatusTrackerContext/index.es.js';

const StatusTrackerDescription = ({ children, className, status, ...rest })=>{
    const { loading } = useStatusTrackContext();
    return jsx("span", {
        className: classNames('cb-status-tracker-step-description', status, className),
        ...rest,
        children: jsx(SkeletonBox, {
            loading: loading,
            children: children
        })
    });
};
StatusTrackerDescription.displayName = 'StatusTrackerDescription';

export { StatusTrackerDescription };
//# sourceMappingURL=StatusTrackerDescription.es.js.map
